import React, { useMemo, useState } from 'react';
import { AccordionItemHeader } from 'src/ui/common/molecules/accordion/accordion-item-header';
import { AccordionProvider } from 'src/ui/common/molecules/accordion/accordion.provider';
import { IAccordionProps, IOAccordion } from 'src/ui/common/molecules/accordion/accordion.types';
import { OAccordionItemContent } from 'src/ui/white-labels/ocean/molecules/accordion/o-accordion-item-content';

export const Accordion: IOAccordion<IAccordionProps> = ({ initialOpenedId, handleItemClick, children }) => {
    const [openedItemId, setOpenedItemId] = useState(initialOpenedId || null);

    const contextValue = useMemo(
        () => ({
            openedItemId,
            setOpenedItemId,
            handleItemClick,
        }),
        [openedItemId, setOpenedItemId, handleItemClick]
    );

    return <AccordionProvider.Provider value={contextValue}>{children}</AccordionProvider.Provider>;
};

Accordion.ItemHeader = AccordionItemHeader;
Accordion.ItemContent = OAccordionItemContent;
